import { IAgedCareDashboardResponse, IKPIData, ITimeSpan } from "./types/agedCareDashboardTypes"

const toRequredFormat = (num: number|null|undefined) => ('0' + num??0).slice(-2);

const createKPIData = (userRoles: any, agedCareDashboardResponse?: IAgedCareDashboardResponse): IKPIData => {
    if(agedCareDashboardResponse){
        return {
            totalCallouts: agedCareDashboardResponse.recordCount ?? 0,
            calloutsPerDay: agedCareDashboardResponse.recordCountDaily ?? 0,
            averageAcknowledgeTime: agedCareDashboardResponse.averageAcknowledgeTime,
            averageAttendTime: agedCareDashboardResponse.averageAttendTime,
            averageCalloutDuration: agedCareDashboardResponse.averageCalloutDuration,
            transferredViaAmbulance: agedCareDashboardResponse.transferredViaAmbulanceCount ?? 0,
            transferredViaAmbulancePercentage: agedCareDashboardResponse.transferredViaAmbulancePercentage ?? 0,
            avgCalloutsNPSSurvey: agedCareDashboardResponse.avgCalloutsNPSSurvey ?? 0,
            userRoles: userRoles,
            timeToAcknowledgeRedAlert: agedCareDashboardResponse.timeToAcknowledgeRedAlert,
            timeToAcknowledgeYellowAlert: agedCareDashboardResponse.timeToAcknowledgeYellowAlert,
            timeToAttendRedAlert: agedCareDashboardResponse.timeToAttendRedAlert,
            timeToAttendYellowAlert: agedCareDashboardResponse.timeToAttendYellowAlert,
            calloutsPerDayRedAlert: agedCareDashboardResponse.calloutsPerDayRedAlert,
            calloutsPerDayYellowAlert: agedCareDashboardResponse.calloutsPerDayYellowAlert,
            calloutsNPSSurveyRedAlert: agedCareDashboardResponse.calloutsNPSSurveyRedAlert,
            calloutsNPSSurveyYellowAlert: agedCareDashboardResponse.calloutsNPSSurveyYellowAlert,
        }
    }
    else{
        return {
            totalCallouts: 0,
            calloutsPerDay: 0,
            averageAcknowledgeTime: null,
            averageAttendTime: null,
            averageCalloutDuration: null,
            transferredViaAmbulance: 0,
            transferredViaAmbulancePercentage: 0,
            avgCalloutsNPSSurvey: 0,
            userRoles: userRoles,
            timeToAcknowledgeRedAlert: null,
            timeToAcknowledgeYellowAlert: null,
            timeToAttendRedAlert: null,
            timeToAttendYellowAlert: null,
            calloutsPerDayRedAlert: null,
            calloutsPerDayYellowAlert: null,
            calloutsNPSSurveyRedAlert: null,
            calloutsNPSSurveyYellowAlert: null
        }
    }
}

const minutesHoursFromTimeSpan = (timeSpan: ITimeSpan | null): string =>{
    if(!timeSpan)
        return '0';

    let hours = timeSpan.hours??0;
    let hoursAndDays = 0;
    if(timeSpan.days){
        hoursAndDays = 24*timeSpan.days;
    }    
    hours = ((hours + hoursAndDays) > 99)? 99 : (hours + hoursAndDays);
    const minutes = timeSpan.minutes??0;

    return `${toRequredFormat(hours)}:${toRequredFormat(minutes)}`
}

const timeStampToMinutes = (timeSpan: ITimeSpan | null): number | null =>{
    if(timeSpan === null)
        return null;
    return timeSpan.totalMinutes;  
}

export {
    createKPIData,
    minutesHoursFromTimeSpan,
    timeStampToMinutes
}